if (!customElements.get('bundle-slider')) {
  customElements.define(
    'bundle-slider',
    class BundleSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items || '1');
        this.itemsMobile = parseInt(this.dataset.itemsMobile || '2');

        if (!this.sliderWrapper || !this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }
      init() {
        if (this.sliderInstance) return;
        const columnGap = getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap') || '1rem';
        const spaceBetween = parseFloat(columnGap) * 10;
        this.sliderOptions = {
          slidesPerView: this.items,
          spaceBetween,
          navigation: {
            nextEl: this.querySelector(this.selectors.nextEl),
            prevEl: this.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.querySelector(this.selectors.pagination),
            clickable: true,
            dynamicBullets: true,
          },
          breakpoints: {
            768: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          // threshold: 2,
        };

        // Add only if not already present via Liquid
        this.classList.add(this.classes.swiper);

        //   Initialize using theme's carousel
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.adjustNavButtons();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }

      adjustNavButtons() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia?.clientHeight > 0) {
          this.style.setProperty('--swiper-navigation-top-offset', `${firstMedia.clientHeight / 2}px`);
        }
      }

      calcHeadingColumnHeight() {
        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia?.clientHeight > 0) {
          this.style.setProperty('--heading-column-height', `${firstMedia.clientHeight}px`);
        }
      }

      fixQuickviewDuplicate() {
        const seenIds = new Set();
        this.querySelectorAll('quick-view-modal').forEach((modal) => {
          const id = modal.getAttribute('id');
          if (seenIds.has(id)) {
            modal.remove();
          } else {
            seenIds.add(id);
          }
        });
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        if (this.sliderInstance?.slider) {
          this.sliderInstance.slider.destroy();
        }
        this.sliderInstance = false;
      }
    }
  );
}
